import { Query } from '@skedulo/protobuf-web'
import { FieldSchema } from './parse-query-to-request-filter'

/**
 * Flattens a DataSchema into a FieldSchema for use with the parser.
 * Handles nested fields like "Resource.Name" or "Job.CreatedDate".
 */
export function flattenSchema(dataSchema: Query.API.DataSchema): FieldSchema {
  const schema: FieldSchema = {}

  const walk = (fields: Query.API.DataField[], prefix = '') => {
    fields.forEach((field) => {
      const path = prefix ? `${prefix}.${field.name}` : field.name
      schema[path] = field.kind
      if (field.relatedObject?.schema?.fields) {
        walk(field.relatedObject.schema.fields, path)
      }
    })
  }

  if (dataSchema.fields) walk(dataSchema.fields)
  return schema
}
